














	import Vue from "vue";

	export default Vue.extend({
		props: ['current', 'countAll', 'countOnPage', 'url'],
		computed: {
			currentPage(): number {
				let current = this.current < 1 ? 1 : (this.current > this.total ? this.total : this.current);
				return current;
			},
			total(): number {
				return Math.ceil(this.countAll / this.countOnPage);
			},
			pages(): number[] {
				if (this.total < 3)
				{
					return [];
				}
				if (this.total < 4)
				{
					return [2];
				}
				if (this.total < 5)
				{
					return [2, 3];
				}
				if (this.total < 6)
				{
					return [2, 3, 4];
				}
				let current = this.currentPage > 2 ? this.currentPage : 3;
				current = this.total - current <= 1 ? this.total-2 : current;
				let pages: number[] = [];
				let page = current-1;
				for (let i = 0; i < 3; i++)
				{
					pages[i] = (page);
					page++;
				}

				return pages;
			}
		},
		methods: {
			setPage(page: number) {
				if (page > this.total || page < 1) {
					return
				}
				this.$emit('update', page)
			}
		}
	})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/Pagination.vue